import type { ModuleFile } from '../../core/modules.ts';

// Módulo «direction»: manifiesto. Las pantallas se cargan de forma perezosa.
export const manifests: ModuleFile['manifests'] = [
  {
    id: 'direction',
    title: 'Dirección',
    projectTab: { segment: 'direccion', label: 'Dirección', order: 4 },
    load: () => import('./DirectionPage.tsx').then((m) => ({ default: m.DirectionPage })),
  },
];
